import React, { Component } from "react";
import MaterialTable from "material-table";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import UserManagement from "./UserManagement";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import { ProfileList_Url, UserList_Url } from "../../../provider/ServiceUrl";
// import ProfileMgmntDialogue from "../profileManagement/ProfileMgmntDialogue";
import TablePagination from "@material-ui/core/TablePagination";
import "./UserManagementList.css";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import EmailIcon from "@mui/icons-material/Email";
import PtsAlert from "../ptsAlert/PtsAlert";

class UserManagementList extends Component {
  header = store.getState().header.header;
  breadCrumb = [{ pageid: "", uiname: "User List" }];
  userState = store.getState().applicationState.userState;
  appuser = store.getState().appUserData.appUserData.appuser;
  userStateDetails = {};
  constructor(props) {
    super(props);
    if (this.userState) {
      this.userStateDetails = Object.getOwnPropertyNames(this.userState);
    }
    if (this.userStateDetails.length > 0) {
      this.state = {
        action: props.action,
        initialPage: this.userState.initialPage,
        pageSize: this.userState.pageSize,
        userList: [],
        profileList: [],
        isPaging: false,
        render: false,
        open: false,
        getCreatePermission: false,
        userId: this.userState.userId,
        profileId: "",
        profile: null,
      };
    } else {
      this.state = {
        action: props.action,
        initialPage: 0,
        pageSize: 20,
        userList: [],
        profileList: [],
        isPaging: false,
        render: false,
        getCreatePermission: false,
        userId: "",
        profileId: "",
        profileName: "",
        profileDescription: "",
        open: false,
      };
    }
    this.getUserList();
    this.getUserProfileList();
  }

  getUserList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(UserList_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        let userList = output.data.appuserList;
        let getPermission = Utils.getRolePermission(output.data?.privilegeList);
        let getCreatePermission = getPermission[1];
        let isPaging = false;
        if (userList.length > this.state.pageSize) {
          isPaging = true;
        }
        for (let i = 0; i < userList.length; i++) {
          userList[i].phone = Utils.viewPhoneNumberFormate(userList[i].phone);
        }
        this.setState({
          render: true,
          action: "userList",
          isPaging: isPaging,
          userList: userList,
          initialPage: this.state.initialPage,
          getCreatePermission: getCreatePermission,
        });
      } else {
      }
    });
  }

  getUserProfileList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(ProfileList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let profileList = output.data.profileList;
          this.setState({
            profileList: profileList,
          });
        } else {
        }
      }
    );
  }

  async addUser() {
    this.setState({
      action: "create",
      profileList: this.state.profileList,
    });
  }

  toUserName(rowData) {
    return (
      <span
        className="anchortag action-text"
        onClick={(e) => this.toUserDetails(e, rowData)}
      >
        {rowData.name}
      </span>
    );
  }

  toUserEmail(rowData) {
    return (
      <span
        className="anchortag"
        onClick={(e) => this.toUserDetails(e, rowData)}
      >
        {rowData.email}
      </span>
    );
  }

  toUserDetails(e, data) {
    if (e.target.closest(".action-button")) return;
    let userState = {
      userId: data.id,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ userState }));
    this.setState({
      action: "view",
      userId: data.id,
      profileList: this.state.profileList,
    });
  }

  // toProfileDetails(e, data) {
  //   if (
  //     this.referenceProfileDialogueRef &&
  //     this.referenceProfileDialogueRef.current
  //   ) {
  //     this.referenceProfileDialogueRef.current.getProfileDetails(
  //       data.profileId
  //     );
  //   }
  // }

  handleOpen(e, data) {
    this.setState({
      open: true,
      profileName: data.profileName,
      profileDescription: data.profileDescription,
    });
  }
  handleClose() {
    this.setState({
      open: false,
    });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  requestToMakePrimaryUser(data) {
    const postObject1 = {
      header: this.header,
      appuser: {
        id: data.id
      }
    };
    FetchServerData.callPostService(
      "/appuserms/requestToMakePrimaryUser",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getUserList();
      } else {
      }
    });
  }

  approveMakePrimaryUserToBackend(data) {
    const postObject1 = {
      header: this.header,
      appuser: {
        id: data.id
      }
    };
    FetchServerData.callPostService(
      "/appuserms/makePrimaryUser",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getUserList();
      } else {
      }
    });
  }


  showActionButton(rowData) {
    return (
      <>
        {(!rowData.isRegistered && rowData?.profileName === "Admin") &&
          <div className="row d-flex action-button" style={{ float: "center" }}>
            <div className="col-md-12 d-flex">
              {(!rowData.isMakePrimaryRequested) &&
                <Button
                  variant="contained"
                  // size="small"
                  style={{
                    background: "#d3d8de",
                    color: "#353538",
                    textTransform: "capitalize",
                    padding: "2px 10px",
                  }}
                  startIcon={<EmailIcon />}
                  onClick={this.requestToMakePrimaryUser.bind(this, rowData)}
                >
                  Make Primary Request
                </Button>
              }
              {rowData.isMakePrimaryRequested &&
                <Button
                  type="button"
                  variant="contained"
                  id="ptsButton"
                  style={{
                    background: "green",
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    padding: "2px 10px",
                  }}
                  onClick={this.approveMakePrimaryUserToBackend.bind(
                    this, rowData
                  )}
                >
                  Approve
                </Button>
              }
            </div>
          </div>
        }
      </>
    )
  }

  render() {
    this.referenceProfileDialogueRef = React.createRef();

    if (this.state.action === "userList") {
      return this.userList();
    } else {
      return (
        <UserManagement
          action={this.state.action}
          userId={this.state.userId}
          profileList={this.state.profileList}
        />
      );
    }
  }
  userList() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        {/* <ProfileMgmntDialogue
          ref={this.referenceProfileDialogueRef}
          style={{ float: "right" }}
        /> */}

        <div
          className="materialTable userManagementTable"
          style={{ maxWidth: "100%" }}
          id="userList"
        >
          <MaterialTable
            title=""
            // onRowClick={(event, rowData) => {
            //   this.toUserDetails(event, rowData);
            //   event.stopPropagation();
            // }}
            icons={UiUtils.getMaterialTableIcons()}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 className="dataNotAvailable">Please add user</h5>
                ),
              },
            }}
            columns={[
              {
                title: "#",
                render: (rowData) => rowData.tableData.id + 1,
                width: "5%",
                align: "left",
                cellStyle: {
                  width: "6%",
                },
              },
              {
                title: "Name",
                field: "name",
                render: (rowData) => this.toUserName(rowData),
                cellStyle: {
                  width: "18%",
                },
              },
              {
                title: "Email",
                field: "email",
                render: (rowData) => this.toUserEmail(rowData),
                cellStyle: {
                  width: "20%",
                  textTransform: "lowercase",
                },
              },
              {
                title: "Phone",
                field: "phone",
                cellStyle: {
                  width: "15%",
                },
              },
              {
                title: "Profile",
                field: "profileName",
                render: (rowData) => {
                  return (
                    <>
                      <Tooltip
                        title={rowData?.profileDescription || ""}
                        classes={{ popper: "custom-tooltip" }}
                        arrow
                      >
                        <span className="anchortag" >{rowData?.profileName || ""}</span>
                      </Tooltip>
                      <span className="ps-1">{rowData.isRegistered ? "(Primary)" : ""}</span>
                    </>
                  );
                },
                cellStyle: {
                  width: "15%",
                },
              },
              {
                title: "Status",
                field: "status",
                cellStyle: {
                  width: "10%",
                },
                filtering: false,
              },
            ]}
            data={this.state.userList}
            options={{
              toolbarButtonAlignment: "left",
              sorting: true,
              search: false,
              actionsColumnIndex: -1,
              initialPage: this.state.initialPage,
              pageSize: this.state.pageSize,
              paging: this.state.isPaging,
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.id === this.state.userId ? "#e6effc" : "",
                height: "3em",
                textTransform: "capitalize",
              }),
            }}
            onChangePage={(page, pageSize) => {
              this.handleMaterialTablePageChange(page, pageSize);
            }}
            actions={[
              {
                icon: () =>
                  this.state.getCreatePermission && (
                    <span>
                      <Button
                        id="ptsGreenSolidButton"
                        variant="contained"
                        type="submit"
                        startIcon={<AddIcon style={{ fontWeight: "600" }} />}
                      >
                        Add New User
                      </Button>
                    </span>
                  ),
                tooltip: "Add New User",
                isFreeAction: true,
                onClick: (event) => this.addUser(),
              },
            ]}
            components={{
              Pagination: (props) => {
                const {
                  page,
                  count,
                  rowsPerPage,
                  onPageChange,
                  onRowsPerPageChange,
                } = props;

                const totalPages = Math.ceil(count / rowsPerPage);
                const currentPage = page + 1;

                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 1rem",
                    }}
                  >
                    <div>
                      Page {currentPage} of {totalPages}
                    </div>
                    <TablePagination
                      {...props}
                      rowsPerPageOptions={props.rowsPerPageOptions}
                      component="div"
                      count={count}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={onPageChange}
                      onRowsPerPageChange={onRowsPerPageChange}
                    />
                  </div>
                );
              },
            }}
          />
        </div >

        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent className="p-4">
            <div className="row d-flex">
              <div className="col-sm-2 ps-0 text-end">
                <p className="m-0" style={{ fontSize: "16px" }}>
                  <span className="fw-bold">{this.state.profileName} - </span>
                </p>
              </div>
              <div className="col-sm-10 p-0">
                <p className="m-0" style={{ fontSize: "16px" }}>
                  {this.state.profileDescription}
                </p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default withRouter(UserManagementList);
